import LoopFront from "loop-front";
import { WeeklyTechDialogFormProps } from "Features/WeeklyTech/WeeklyTechDialogForm";
import { ActionCreator } from "Typings/Global";

const CustomActions = {
    SHOW_WEEKLY_TECH_DIALOG_FORM: 'SHOW_WEEKLY_TECH_DIALOG_FORM',
    HIDE_WEEKLY_TECH_DIALOG_FORM: 'HIDE_WEEKLY_TECH_DIALOG_FORM',
}

const CustomActivities = {
    TOGGLE_PUBLISH: 'publish',
    TOGGLE_FEATURED: 'featured'
}

class WeeklyTech extends LoopFront<typeof CustomActions, {}, typeof CustomActivities> {
    constructor() {
        super('weeklyPosts', CustomActions, {}, CustomActivities);
    }
    showWeeklyTechForm = (props: Omit<WeeklyTechDialogFormProps, 'open'>): ActionCreator => dispatch => dispatch({ type: this.Actions.SHOW_WEEKLY_TECH_DIALOG_FORM, data: props });
    hideDialogForm = (): ActionCreator => dispatch => dispatch({ type: this.Actions.HIDE_WEEKLY_TECH_DIALOG_FORM });
}

export const OWeeklyTech = new WeeklyTech();